import React from 'react';

export const DELIVERY_DATE_CONTEXT_DEFAULT = 'DEFAULT';
export const DELIVERY_DATE_CONTEXT_ISOLATED = 'ISOLATED';

export type PageContext =
  | typeof DELIVERY_DATE_CONTEXT_DEFAULT
  | typeof DELIVERY_DATE_CONTEXT_ISOLATED;

type ContextState = {
  pageContext?: PageContext;
  isolatedContextDeliveryDate?: string;
  setIsolatedContextDeliveryDate?: (val: string) => void;
};

const defaultContextState: ContextState = {
  pageContext: DELIVERY_DATE_CONTEXT_DEFAULT
};

export const DeliveryDateContext = React.createContext(defaultContextState);

export const chooseDeliveryDateFromContext = (
  contextState: ContextState,
  deliveryDate: string | undefined
) => {
  return contextState.pageContext === DELIVERY_DATE_CONTEXT_DEFAULT
    ? deliveryDate
    : contextState.isolatedContextDeliveryDate;
};
